import { Actions, Effect } from "@ngrx/effects";
import { AppState } from "@store/state";
import { catchError, mergeMap, switchMap, map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { of } from "rxjs";
import { ofAction } from "ngrx-actions";
import { Store } from "@ngrx/store";
import { StorageService, StoreDetailService, StoreConfigService } from "@tendercuts/providers";
import { Store as TenderCutsStore, StoreConfig } from "@tendercuts/models";
import "rxjs/add/observable/forkJoin";
import {
  ActionLoadStoreEdcMachines,
  ActionLoadStores,
  ActionSetCurrentStore,
  ActionSetCurrentStoreEdcMachines,
  ActionStoresLoadEdcMachinesFailed,
  ActionStoresLoadEdcMachinesSuccess,
  ActionStoresLoadFailed,
  ActionStoresLoadSuccess,
  ActionUpdateSelectedEdcMachine,
  ActionUpdateSelectedEdcMachineDone,
  ActionLoadStoreConfig,
  ActionLoadStoreConfigSuccess,
  ActionLoadStoreConfigFailed,
} from "./store-state-actions";
import { StoreEdcMachinesService } from "src/providers/store/store-edc-machines";
import { EdcMachine } from "@tendercuts/models/store/edc-machine";


@Injectable()
export class StoreEffects {
  constructor(
    private actions$: Actions,
    private storeDetailService: StoreDetailService,
    private storeEdcMachinesService: StoreEdcMachinesService,
    private storage: StorageService,
    private storeConfigService: StoreConfigService,
    public store: Store<AppState>
  ) {}

  /**
   * Effect to load overall store details and current store detail,
   * storeAddress from storeAddressService and set to storeDetailService (TenderCutsStore) address
   */
  @Effect()
  loadStores = this.actions$.pipe(
    ofAction(ActionLoadStores),
    switchMap((action: ActionLoadStores) => {
      let userStoreId = action.userStoreId;
      let totalStores = this.storeDetailService.getData();

      return totalStores.pipe(
        mergeMap((result) => {
          let currentStore;
          result.forEach((response: TenderCutsStore) => {
            if (response.storeId.toLocaleString() == userStoreId) {
              currentStore = response;
            }
          });
          return [
            new ActionStoresLoadSuccess(result),
            new ActionSetCurrentStore(currentStore),
            new ActionLoadStoreEdcMachines(userStoreId)
          ];
        }),
        catchError((err) => of(new ActionStoresLoadFailed(err)))
      );
    })
  );


  /**
   * Effect to load edc machines and set current store edc machines
   */
  @Effect()
  loadEdcMachines = this.actions$.pipe(
    ofAction(ActionLoadStoreEdcMachines),
    switchMap((action: ActionLoadStoreEdcMachines) => {
      let userStoreId = action.userStoreId;
      let edcMachines = this.storeEdcMachinesService.getData();
      return edcMachines.pipe(
        mergeMap((result) => {
          const currentStoreEdcMachines = result.find(
            (storeData) => storeData.storeId.toLocaleString() == userStoreId
          ).edcMachines;
          return [
            new ActionStoresLoadEdcMachinesSuccess(result),
            new ActionSetCurrentStoreEdcMachines(currentStoreEdcMachines),
          ];
        }),
        catchError((err) => of(new ActionStoresLoadEdcMachinesFailed(err)))
      );
    })
  );
  
  /**
   * Update the local cart quote with current redux cart quote
   */
   @Effect()
   updateSelectedEdcMachine$ = this.actions$.pipe(
     ofAction(ActionUpdateSelectedEdcMachine),
     map((action: ActionUpdateSelectedEdcMachine) => {
         this.storage.storeData("selected_edc_machine", action.selectedEdcMachine);
       return new ActionUpdateSelectedEdcMachineDone();
     })
   );

   
  /**
   * Effect to load overall store store config datas,
   */
  @Effect()
  loadStoreConfig = this.actions$.pipe(
    ofAction(ActionLoadStoreConfig),
    switchMap((action: ActionLoadStoreConfig) => {
      let storeConfig = this.storeConfigService.getData(
        this.storeConfigService.getParams(
          action.userStoreId
        )
      );

      return storeConfig.pipe(
        mergeMap((response: StoreConfig[]) => {
          return [
            new ActionLoadStoreConfigSuccess(response),
          ];
        }),
        catchError((err) => of(new ActionLoadStoreConfigFailed(err)))
      );
    })
  );
}
